<!-- This component is shown with an animation. We can not add another animation to this component (angular bug), so we create an extra sub-component as a solution -->

<tun-search-text-content-view
  [canReceiveFocus]="canReceiveFocus"
  (back)="onBack()"
  class="wrapper"
>

</tun-search-text-content-view>
